import {createColumnHelper} from '@tanstack/react-table'

const columnHelper = createColumnHelper()

export const listaSlownikowColumns = [
    columnHelper.accessor('unit', {
            header: 'ID',
            enableColumnFilter: false,
        },
    ),

    {accessorFn: (row) => row.label, header: 'Nazwa słownika'},


]